export default __webpack_public_path__ + "static/link-item-icon-do-59ebae953babcc83846a93175d7ac7d7.png";